import { RiskIssue } from '../../../../typings/enums';

const ISSUE_INDEX = {
  unlicensed_dependency: {
    title: 'Unlicensed Dependencies', // or: Copyrighted Dependencies
    description: (
      <span>
        This package contains unlicensed code, which by default is copyrighted to the original author. You{' '}
        <b>may not</b> use these dependencies without first obtaining a license.
      </span>
    ),
    fixable: true,
  },
  unrecognized_license: {
    title: 'Unrecognized Licenses',
    description: (
      <span>FOSSA doesn&apos;t recognize these licenses. Either declare the license or submit it to TLDRLegal.</span>
    ),
  },
  conflicting_terms: {
    title: 'Conflicting Terms',
    description:
      'Some licenses seem like they have conflicting terms.  It is important to review and fix these immediately.',
  },
  policy_conflict: {
    title: 'Denied License Issues',
    description: <span>These licenses conflict with your policy.</span>,
    fixable: true,
  },
  policy_flag: {
    title: 'Flagged License Issues',
    description: (
      <span>
        These licenses can be problematic if used in the wrong ways. You must manually review and approve their usage.
      </span>
    ),
    fixable: true,
  },
  vulnerability: {
    title: 'Vulnerabilities',
    description: (
      <span>
        These dependencies contain security vulnerabilities that could lead to possible exploits within your
        application. Have a technical team member review these.
      </span>
    ),
  },
  vulnerability_group: {
    title: 'Vulnerabilities',
    description: (
      <span>
        Multiple vulnerabilities were found. Select a vulnerability from the list below to view more information and remediation instructions.
      </span>
    ),
  },
  outdated_dependency: {
    title: 'Outdated Dependencies',
    description: (
      <span>
        These dependencies have been flagged as outdated by your policy. This may either be an out of date Major, Minor, or Patch version.
      </span>
    ),
    fixable: true,
  },
  blacklisted_dependency: {
    title: 'Blocked Dependencies',
    description: (
      <span>
        These dependencies have been blocked by your policy.
      </span>
    ),
    fixable: true,
  },
  [RiskIssue.abandonware]: {
    title: 'Abandoned Dependencies',
    description: (
      <span>
        These dependencies have not received updates in over two years and may have been abandoned.
      </span>
    ),
    fixable: true,
  },
  [RiskIssue.emptyPackage]: {
    title: 'Empty Dependencies',
    description: (
      <span>
        These dependencies have no reasonable source code and are considered empty.
      </span>
    ),
    fixable: false,
  },
  [RiskIssue.nativeCode]: {
    title: 'Native Code Detected',
    description: (
      <span>
        These dependencies contain compiled executables that are not expected within their ecosystem.
      </span>
    ),
    fixable: false,
  },
};

export default ISSUE_INDEX;
